import React, { useEffect } from "react";
import styles from "./SyncButton.module.css";
import Group from "../../assets/icons/successCheck.svg";

const SyncERPSuccess = ({ onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={styles.overlay}>
      <div className={styles.popupContainer}>
        <div className={styles.iconWrapper}>
          <img src={Group} alt="Success" />
        </div>
        <p className={styles.message}>Pulled from ERP Successfully</p>
      </div>
    </div>
  );
};

export default SyncERPSuccess;
